<template>
    <transition name="modal">
        <div>
            <div class="modal" tabindex="-1" role="dialog" @keyup.esc="closeModal">
                <div class="modal__dialog">
                    <button class="modal__close" type="button" @click="closeModal">
                        x
                    </button>
                    <div class="modal__content">
                        <slot/>
                        <h3 class="u-padding-bottom">{{ trans('ssl.upload-private-modal-title') }}</h3>
                        <div class="layout">
                            <div class="layout__item u-padding-bottom-narrow">
                                {{ trans('ssl.private-key-description') }}
                            </div>
                        </div>
                        <div role="alert" dusk="alert" class="alert alert--danger" v-if="error">
                            {{ error }}
                            <button type="button" aria-label="Close" class="alert-close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <label for="custom_csr">{{ trans('ssl.private-input-title') }}</label>
                        <textarea
                            id="custom_csr"
                            name="custom_csr"
                            class="field__message"
                            v-model="privateKeyField"
                            rows="10"
                            @input="privateKeyTextOnChange"
                        >
                        </textarea>

                        <div class="layout">
                            <div class="layout__item u-text-right">
                                <button
                                    v-model="privatekeyIsValidated"
                                    type="button"
                                    class="btn btn--ghost"
                                    @click="validatePrivateKey"
                                >
                                    {{ trans('ssl.validate-private-key') }}
                                </button>
                            </div>
                        </div>
                        <div class="layout u-padding-top">
                            <div class="layout__item u-2/4-desk">
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn--ghost-gray"
                                        @click="closeModal"
                                    >
                                        {{ trans('action.cancel') }}
                                    </button>
                                </div>
                            </div>
                            <div class="layout__item u-2/4-desk u-text-right">
                                <button
                                    :disabled="!privatekeyIsValidated"
                                    type="button"
                                    class="btn btn--blue btn--nav"
                                    @click="submitPrivateKey"
                                >
                                    {{ trans('action.save') }}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop" role="presentation" @click="clickBackdrop"/>
            <div v-if="isLoading" class="spinner-wrapper">
                <div class="overlay"/>
                <span class="spinner"/>
            </div>
        </div>
    </transition>
</template>

<script>
import {SslApi} from 'relapp-technical-management';

export default {
    name: "SslPrivateKeyModal",
    props: {
        isLoading: {
            type: Boolean,
            required: false
        },
        closeOnClickBackdrop: {
            type: Boolean,
            required: false
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            privateKeyField: '',
            privatekeyIsValidated: false,
            error: null
        }
    },
    computed: {
        /**
         * Generate the state classes.
         *
         * @return {object}
         */
        stateClasses() {
            return {
                'has-error': this.error
            };
        }
    },
    methods: {
        /**
         * Handle clicks on the backdrop.
         */
        clickBackdrop() {
            if (this.closeOnClickBackdrop) {
                this.closeModal();
            }
        },
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
            this.$root.$emit('closedModal');
            this.privateKeyField = '';
        },
        /**
         * After changing the textarea we dont want the to submit any weird changes.
         */
        privateKeyTextOnChange() {
            this.privatekeyIsValidated = false;
        },
        /**
         * Validating the private key.
         */
        validatePrivateKey() {
            this.privatekeyIsValidated = false;
            this.error = null;
            SslApi.validatePrivateKey(this.subscription.domain, this.privateKeyField)
                .then( response => {
                    this.privatekeyIsValidated = true;
                })
                .catch( error => {
                    this.error = error.data.message;
                });
        },
        /**
         * Submitting the private key.
         */
        submitPrivateKey() {
            SslApi.submitPrivateKey(this.subscription.domain, this.privateKeyField)
                .then( response => {
                    this.closeModal();
                })
                .catch( error => {
                    this.error = error.data.message;
                });
        }
    }
};
</script>

